const Logo = ({ className }) => {
  return (
    <div className={className}>
      <svg
        width="252"
        height="141"
        viewBox="0 0 252 141"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M127.044 140.313L185.948 90.3426L169.438 75.496L127 65.5545L84.6063 75.496L68.2268 90.2988L127.044 140.313Z"
          fill="#5CCAE8"
        />
        <path
          d="M5.24927 37.0438L127.044 140.313"
          stroke="black"
          strokeWidth="0.5"
        />
        <path
          d="M5.24927 37.0438L146.182 124.109"
          stroke="black"
          strokeWidth="0.5"
        />
        <path
          d="M5.24927 37.0438L160.284 112.196"
          stroke="black"
          strokeWidth="0.5"
        />
        <path
          d="M248.751 37.0438L93.8471 112.284"
          stroke="black"
          strokeWidth="0.5"
        />
        <path
          d="M248.751 37.0438L107.949 124.109"
          stroke="black"
          strokeWidth="0.5"
        />
        <path
          d="M248.751 37.0438L127.044 140.313"
          stroke="black"
          strokeWidth="0.5"
        />
        <path
          d="M127.044 37L68.2268 90.2988"
          stroke="black"
          strokeWidth="0.5"
        />
        <path
          d="M127.044 37.0438L83.2923 103.218"
          stroke="black"
          strokeWidth="0.5"
        />
        <path
          d="M127.044 37.0438L107.861 124.021"
          stroke="black"
          strokeWidth="0.5"
        />
        <path
          d="M127.044 37.0438L146.139 124.021"
          stroke="black"
          strokeWidth="0.5"
        />
        <path
          d="M127.044 37.0438L170.795 103.218"
          stroke="black"
          strokeWidth="0.5"
        />
        <path
          d="M127.088 37L185.905 90.3426"
          stroke="black"
          strokeWidth="0.5"
        />
        <path
          d="M248.751 37.0438L83.2923 103.218"
          stroke="black"
          strokeWidth="0.5"
        />
        <path
          d="M74.8837 96.1673L248.751 37.0438"
          stroke="black"
          strokeWidth="0.5"
        />
        <path
          d="M248.751 37.0438L68.2268 90.2988"
          stroke="black"
          strokeWidth="0.5"
        />
        <path
          d="M5.24927 37.0438L170.751 103.218"
          stroke="black"
          strokeWidth="0.5"
        />
        <path
          d="M179.16 96.1235L5.24927 37.0438"
          stroke="black"
          strokeWidth="0.5"
        />
        <path
          d="M5.24927 37.0438L185.905 90.2988"
          stroke="black"
          strokeWidth="0.5"
        />
        <path
          d="M68.2268 90.2988L185.905 90.3426"
          stroke="black"
          strokeWidth="0.5"
        />
        <path
          d="M83.2923 103.218L170.708 103.306"
          stroke="black"
          strokeWidth="0.5"
        />
        <path
          d="M107.949 124.153L146.182 124.109"
          stroke="black"
          strokeWidth="0.5"
        />
        <path
          d="M77.6865 81.7587L248.751 37.0438"
          stroke="black"
          strokeWidth="0.5"
        />
        <path
          d="M248.751 37.0438L84.6063 75.496"
          stroke="black"
          strokeWidth="0.5"
        />
        <path
          d="M176.401 81.7587L5.24927 37.0438"
          stroke="black"
          strokeWidth="0.5"
        />
        <path
          d="M5.24927 37.0438L169.438 75.496"
          stroke="black"
          strokeWidth="0.5"
        />
        <path d="M77.6865 81.7587H176.357" stroke="black" strokeWidth="0.5" />
        <path d="M84.6063 75.496H169.525" stroke="black" strokeWidth="0.5" />
        <path
          d="M11.3332 17.5406H11.9297C11.9756 17.8503 12.0138 18.1987 12.0444 18.5858C12.0903 18.9729 12.1209 19.3677 12.1362 19.7703C12.1668 20.1729 12.1821 20.5677 12.1821 20.9548C12.1974 21.3419 12.1974 21.6903 12.1821 22H0V20.8155L9.54378 6.94966H2.47771L1.07826 10.2013H0.504719C0.458835 9.87611 0.412952 9.51998 0.367068 9.13288C0.336479 8.74578 0.30589 8.35095 0.275301 7.94837C0.260007 7.54578 0.244712 7.15869 0.229418 6.78707C0.229418 6.39998 0.229418 6.05159 0.229418 5.74191H11.9527V6.94966L2.45477 20.7922H9.93379L11.3332 17.5406Z"
          fill="black"
        />
        <path
          d="M30.0356 5.74191C30.0205 6.36127 29.9904 6.98837 29.9451 7.6232C29.9149 8.24256 29.8621 8.86966 29.7866 9.50449H29.1981L28.2701 6.94966H23.3355V13.1045H27.0251L27.9079 11.3858H28.4738C28.5643 12.9187 28.5643 14.4826 28.4738 16.0774H27.9079L27.0251 14.3122H23.3355V20.7922H28.5417L29.6508 18.0051H30.2167C30.3223 18.6555 30.3978 19.3135 30.4431 19.9793C30.4883 20.6451 30.4959 21.3187 30.4657 22H19.3064V21.3264C19.8346 21.0787 20.4533 20.8929 21.1625 20.769V6.99611C20.8607 6.93417 20.5513 6.85675 20.2344 6.76385C19.9175 6.65546 19.6082 6.53933 19.3064 6.41546V5.74191H30.0356Z"
          fill="black"
        />
        <path
          d="M48.2854 5.74191C48.2689 6.36127 48.236 6.98837 48.1866 7.6232C48.1537 8.24256 48.0961 8.86966 48.0138 9.50449H47.3717L46.3593 6.94966H40.9762V13.1045H45.0012L45.9642 11.3858H46.5816C46.6803 12.9187 46.6803 14.4826 46.5816 16.0774H45.9642L45.0012 14.3122H40.9762V20.7922H46.6556L47.8656 18.0051H48.4829C48.5982 18.6555 48.6805 19.3135 48.7299 19.9793C48.7793 20.6451 48.7875 21.3187 48.7546 22H36.5808V21.3264C37.1569 21.0787 37.8319 20.8929 38.6056 20.769V6.99611C38.2764 6.93417 37.9389 6.85675 37.5932 6.76385C37.2475 6.65546 36.91 6.53933 36.5808 6.41546V5.74191H48.2854Z"
          fill="black"
        />
        <path
          d="M54.871 5.74191H60.8088V6.40691C60.5127 6.52921 60.2166 6.63622 59.9205 6.72795C59.6244 6.81967 59.3283 6.90375 59.0322 6.98019V16.359C59.0322 17.1692 59.1179 17.8495 59.2893 18.3998C59.4763 18.9349 59.7413 19.3706 60.0841 19.7069C60.427 20.0279 60.8478 20.2649 61.3465 20.4177C61.8608 20.5553 62.4374 20.6241 63.0764 20.6241C64.3076 20.6241 65.2661 20.2954 65.9518 19.6381C66.6376 18.9654 66.9804 17.8648 66.9804 16.336V7.18657C66.622 7.06427 66.2869 6.94197 65.9752 6.81967C65.6635 6.68208 65.383 6.5445 65.1336 6.40691V5.74191H70.113V6.40691C69.8169 6.57507 69.5129 6.72795 69.2013 6.86553C68.9051 7.00312 68.6012 7.11013 68.2895 7.18657V16.3819C68.2895 17.3603 68.1571 18.2011 67.8921 18.9043C67.6272 19.6075 67.2532 20.1884 66.77 20.6471C66.3025 21.1057 65.7258 21.4496 65.0401 21.6789C64.37 21.893 63.6219 22 62.7959 22C60.8478 22 59.3594 21.5719 58.3309 20.7158C57.3023 19.8445 56.788 18.5145 56.788 16.7259V6.98019C56.149 6.88846 55.51 6.69737 54.871 6.40691V5.74191Z"
          fill="black"
        />
        <path
          d="M95.2618 6.03591C94.9267 5.98738 94.5916 5.9146 94.2565 5.81755C93.9214 5.70433 93.5704 5.57494 93.2034 5.42937V4.72578H98.5647V5.42937C98.0222 5.67198 97.4478 5.87416 96.8415 6.03591L92.8444 21.7088L91.3605 22L87.507 8.80172L83.7253 21.7088L82.2653 22L78.0289 6.03591C77.7098 5.95503 77.3986 5.86608 77.0955 5.76903C76.7923 5.67198 76.4971 5.55876 76.2099 5.42937V4.72578H82.4329V5.42937C82.1297 5.54259 81.8186 5.65581 81.4994 5.76903C81.1803 5.86608 80.8372 5.95503 80.4702 6.03591L82.8398 15.8133L83.3663 18.9673H83.4142L84.2519 15.7648L87.4831 4.72578H88.2968L91.7673 15.7648L92.4614 18.9188H92.5093L93.0598 15.7163L95.2618 6.03591Z"
          fill="black"
        />
        <path
          d="M106.856 20.0674C107.047 20.2582 107.293 20.4253 107.595 20.5684C107.897 20.6957 108.351 20.7593 108.955 20.7593C109.464 20.7593 109.941 20.6957 110.386 20.5684C110.831 20.4253 111.213 20.2264 111.531 19.9719C111.865 19.7015 112.127 19.3834 112.318 19.0176C112.509 18.6358 112.604 18.2063 112.604 17.7292C112.604 17.0929 112.406 16.56 112.008 16.1306C111.626 15.7011 111.141 15.3194 110.553 14.9853C109.981 14.6513 109.352 14.3252 108.669 14.0071C107.985 13.689 107.349 13.3152 106.76 12.8857C106.188 12.4403 105.703 11.9154 105.305 11.311C104.924 10.6906 104.733 9.91918 104.733 8.99662C104.733 8.32855 104.852 7.73207 105.091 7.20716C105.329 6.68225 105.663 6.23688 106.093 5.87103C106.538 5.50519 107.063 5.22683 107.667 5.03596C108.271 4.82918 108.947 4.72578 109.694 4.72578C110.664 4.72578 111.547 4.80532 112.342 4.96438C113.153 5.10753 113.789 5.29046 114.25 5.51314C114.25 5.78355 114.226 6.10167 114.179 6.46752C114.147 6.81746 114.099 7.1833 114.036 7.56505C113.988 7.9468 113.932 8.3206 113.869 8.68644C113.805 9.03638 113.741 9.34655 113.678 9.61696H113.058L112.103 6.34822C111.817 6.22097 111.452 6.12554 111.006 6.06191C110.577 5.99829 110.116 5.96647 109.623 5.96647C108.812 5.96647 108.16 6.19711 107.667 6.65839C107.174 7.10377 106.927 7.73207 106.927 8.54329C106.927 9.19544 107.118 9.74421 107.5 10.1896C107.897 10.635 108.39 11.0326 108.979 11.3826C109.567 11.7325 110.195 12.0745 110.863 12.4085C111.547 12.7266 112.183 13.1004 112.771 13.5299C113.36 13.9594 113.845 14.4684 114.226 15.0569C114.624 15.6454 114.823 16.3771 114.823 17.252C114.823 17.9677 114.688 18.6199 114.417 19.2084C114.163 19.797 113.789 20.298 113.296 20.7116C112.803 21.1251 112.199 21.4433 111.483 21.666C110.768 21.8886 109.957 22 109.05 22C108.049 22 107.15 21.8807 106.355 21.6421C105.56 21.4035 104.995 21.149 104.661 20.8786C104.677 20.6082 104.701 20.2821 104.733 19.9004C104.781 19.5186 104.828 19.1289 104.876 18.7312C104.94 18.3177 105.003 17.92 105.067 17.5383C105.131 17.1565 105.194 16.8304 105.258 16.56H105.878L106.856 20.0674Z"
          fill="black"
        />
        <path
          d="M127.855 22H120.919V21.1308C121.669 20.8112 122.419 20.5714 123.169 20.4116L131.073 0.661255H131.979L139.884 20.4116C140.3 20.4915 140.706 20.5814 141.102 20.6813C141.519 20.7812 141.904 20.931 142.258 21.1308V22H134.26V21.1308C134.677 20.971 135.104 20.8311 135.541 20.7113C135.978 20.5914 136.405 20.4915 136.822 20.4116L134.697 14.927H127.23L125.168 20.4116C126.043 20.5314 126.939 20.7712 127.855 21.1308V22ZM127.855 13.3686H134.166L131.698 7.01492L131.105 4.43749H131.042L130.261 7.07486L127.855 13.3686Z"
          fill="black"
        />
        <path
          d="M153.605 20.7829C153.97 20.8595 154.319 20.9437 154.652 21.0355C154.985 21.1121 155.31 21.2116 155.627 21.334V22H149.371V21.334C149.72 21.181 150.053 21.0661 150.37 20.9896C150.687 20.913 151.004 20.8442 151.322 20.7829V7.16564C150.909 7.0891 150.545 7.0049 150.227 6.91305C149.91 6.80588 149.625 6.69872 149.371 6.59156V5.92562H151.464C152.099 5.92562 152.789 5.895 153.534 5.83377C154.295 5.77253 155.033 5.74191 155.746 5.74191C156.524 5.74191 157.245 5.82611 157.911 5.99451C158.593 6.16291 159.18 6.43081 159.672 6.79823C160.163 7.16564 160.544 7.63256 160.813 8.19899C161.099 8.76542 161.242 9.44667 161.242 10.2427C161.242 11.3603 160.932 12.2865 160.314 13.0213C159.711 13.7561 158.887 14.2843 157.84 14.6058C158.522 15.6468 159.235 16.6801 159.981 17.7058C160.726 18.7315 161.503 19.7496 162.312 20.76L163.597 21.4259V22H160.718L159.814 21.357C159.37 20.8212 158.966 20.3007 158.601 19.7955C158.236 19.275 157.895 18.7545 157.578 18.234C157.261 17.6982 156.96 17.1624 156.674 16.6266C156.405 16.0754 156.127 15.4937 155.842 14.8813H153.605V20.7829ZM155.223 6.93601C154.842 6.93601 154.525 6.94366 154.271 6.95897C154.034 6.97428 153.812 7.0049 153.605 7.05082V13.9169H155.318C156.412 13.9169 157.277 13.5801 157.911 12.9065C158.561 12.2329 158.887 11.345 158.887 10.2427C158.887 9.10987 158.546 8.27554 157.864 7.73973C157.182 7.20391 156.301 6.93601 155.223 6.93601Z"
          fill="black"
        />
        <path
          d="M181.023 17.3713H181.62C181.696 17.8166 181.765 18.3813 181.826 19.0653C181.887 19.7333 181.903 20.3855 181.872 21.0217C181.643 21.2126 181.367 21.3717 181.046 21.4989C180.725 21.6103 180.381 21.7057 180.014 21.7853C179.663 21.8648 179.296 21.9205 178.913 21.9523C178.546 21.9841 178.195 22 177.858 22C176.574 22 175.427 21.833 174.418 21.4989C173.409 21.149 172.553 20.6241 171.85 19.9242C171.162 19.2243 170.626 18.3336 170.244 17.252C169.877 16.1544 169.694 14.8581 169.694 13.3629C169.694 11.8041 169.9 10.4839 170.313 9.40222C170.726 8.30469 171.284 7.41394 171.987 6.72997C172.69 6.0301 173.508 5.5211 174.441 5.20297C175.374 4.88485 176.352 4.72578 177.377 4.72578C178.386 4.72578 179.234 4.79736 179.923 4.94052C180.611 5.06777 181.214 5.2666 181.734 5.537C181.734 5.7915 181.727 6.09372 181.711 6.44366C181.696 6.77769 181.673 7.13558 181.643 7.51733C181.612 7.89908 181.574 8.27288 181.528 8.63872C181.482 9.00457 181.436 9.3386 181.39 9.64082H180.794L179.601 6.20507C179.433 6.10963 179.15 6.046 178.753 6.01419C178.371 5.98238 177.988 5.96647 177.606 5.96647C176.842 5.96647 176.115 6.11758 175.427 6.4198C174.755 6.70611 174.158 7.15944 173.638 7.77979C173.134 8.38422 172.729 9.15568 172.423 10.0941C172.117 11.0167 171.964 12.1063 171.964 13.3629C171.964 14.4922 172.102 15.5182 172.377 16.4407C172.652 17.3474 173.05 18.1268 173.57 18.779C174.089 19.4152 174.724 19.9083 175.473 20.2582C176.222 20.5923 177.071 20.7593 178.019 20.7593C178.524 20.7593 178.944 20.7195 179.28 20.64C179.617 20.5605 179.838 20.4571 179.945 20.3298L181.023 17.3713Z"
          fill="black"
        />
        <path
          d="M194.123 22H187.984V21.3264C188.631 21.0787 189.294 20.8929 189.974 20.769V6.99611C189.213 6.88772 188.55 6.69417 187.984 6.41546V5.74191H194.123V6.41546C193.848 6.55482 193.557 6.67095 193.25 6.76385C192.942 6.85675 192.627 6.93417 192.303 6.99611V13.058H199.923V6.99611C199.583 6.91869 199.259 6.83353 198.952 6.74062C198.661 6.64772 198.378 6.53933 198.103 6.41546V5.74191H204.242V6.41546C203.951 6.5703 203.627 6.69417 203.271 6.78707C202.932 6.86449 202.592 6.93417 202.252 6.99611V20.769C202.624 20.831 202.98 20.9084 203.32 21.0013C203.66 21.0942 203.967 21.2026 204.242 21.3264V22H198.103V21.3264C198.685 21.0787 199.292 20.8929 199.923 20.769V14.2658H192.303V20.769C192.627 20.831 192.942 20.9084 193.25 21.0013C193.557 21.0942 193.848 21.2026 194.123 21.3264V22Z"
          fill="black"
        />
        <path
          d="M216.436 22H210.339V21.3264C210.958 21.0477 211.593 20.8619 212.244 20.769V6.99611C211.926 6.93417 211.609 6.85675 211.291 6.76385C210.974 6.65546 210.656 6.53933 210.339 6.41546V5.74191H216.436V6.41546C216.15 6.53933 215.84 6.65546 215.507 6.76385C215.173 6.85675 214.848 6.93417 214.53 6.99611V20.769C214.864 20.831 215.197 20.9084 215.531 21.0013C215.864 21.0942 216.166 21.2026 216.436 21.3264V22Z"
          fill="black"
        />
        <path
          d="M234.237 5.74191C234.22 6.36127 234.187 6.98837 234.138 7.6232C234.105 8.24256 234.048 8.86966 233.965 9.50449H233.323L232.311 6.94966H226.928V13.1045H230.953L231.916 11.3858H232.533C232.632 12.9187 232.632 14.4826 232.533 16.0774H231.916L230.953 14.3122H226.928V20.7922H232.607L233.817 18.0051H234.434C234.55 18.6555 234.632 19.3135 234.681 19.9793C234.731 20.6451 234.739 21.3187 234.706 22H222.532V21.3264C223.108 21.0787 223.783 20.8929 224.557 20.769V6.99611C224.228 6.93417 223.89 6.85675 223.545 6.76385C223.199 6.65546 222.861 6.53933 222.532 6.41546V5.74191H234.237Z"
          fill="black"
        />
        <path
          d="M244.826 20.769C245.525 20.8619 246.209 21.0477 246.876 21.3264V22H240.822V21.3264C241.093 21.2026 241.371 21.0942 241.657 21.0013C241.943 20.9084 242.237 20.831 242.538 20.769V6.99611C242.189 6.91869 241.871 6.83353 241.585 6.74062C241.299 6.63224 241.045 6.52385 240.822 6.41546V5.74191H252C251.984 6.34578 251.952 6.96514 251.905 7.59998C251.873 8.23482 251.817 8.86966 251.738 9.50449H251.118L250.141 6.94966H244.826V13.5458H249.069L249.926 12.0826H250.498C250.578 12.7793 250.61 13.4839 250.594 14.1961C250.594 14.8929 250.562 15.5974 250.498 16.3097H249.926L249.069 14.7535H244.826V20.769Z"
          fill="black"
        />
      </svg>
    </div>
  );
};

export default Logo;
